/**
 * Parses a profile object from the who-am-i response into a UserProfile.
 *
 * @param {Object} json - A single profile from the profiles[] array
 * @returns {Object} UserProfile with id, email, displayName, avatarUrl
 */
export const parseUserProfile = (json) => {
  if (!json) return {};

  return {
    id: json.id || null,
    email: json.email || "",
    displayName: json.displayName || "",
    avatarUrl: json.avatarUrl || "",
  };
};

export default { parseUserProfile };
